import type { SubscriptionTier } from '../types/platformOrganization';
import type { PlanFeatureKey } from '../hooks/usePlanFeature';

export type PlanFeatureGateMeta = {
  title: string;
  description: string;
  requiredTier: SubscriptionTier;
  requiredPlanLabel: string;
};

export const PLAN_FEATURE_GATES: Record<PlanFeatureKey, PlanFeatureGateMeta> = {
  emailAutomation: {
    title: 'Notificaciones por correo',
    description:
      'Resúmenes semanales, recordatorios de pagos pendientes, facturas vencidas y auditoría de envíos automáticos.',
    requiredTier: 'PROFESSIONAL',
    requiredPlanLabel: 'Profesional'
  },
  advancedReports: {
    title: 'Reportes avanzados',
    description: 'Exportación y reportes detallados para análisis operativo.',
    requiredTier: 'PROFESSIONAL',
    requiredPlanLabel: 'Profesional'
  },
  auditLog: {
    title: 'Registro de auditoría',
    description: 'Historial de quién hizo qué, cuándo y qué cambió en el sistema.',
    requiredTier: 'PROFESSIONAL',
    requiredPlanLabel: 'Profesional'
  },
  apiAccess: {
    title: 'Acceso API',
    description: 'Integraciones y acceso programático a los datos de su funeraria.',
    requiredTier: 'PREMIUM',
    requiredPlanLabel: 'Premium'
  }
};
